import * as React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Col } from 'antd';

import { TRecentButton } from './definitions';
import Text from 'Pages/Home/Components/Atoms/Text';
import Styles from './RecentButton.module.scss';

export default function RecentButton({ text, onClick }: TRecentButton) {
  return (
    <Col
      onClick={onClick}
      className={Styles['recent-button']}
    >
      <Text className={Styles['recent-button-text']}>{text}</Text>
    </Col>
  );
}
